var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPitchicon = function SvgPitchicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.6 11.2c.22 0 .4.18.4.4v.8a.4.4 0 0 1-.4.4h-3.848l1.736 2.48c.071.1.11.22.112.344v.176a.2.2 0 0 1-.2.2h-.944a.8.8 0 0 1-.656-.344l-2-2.856H6.2l-2 2.856a.8.8 0 0 1-.656.344H2.6a.2.2 0 0 1-.2-.2v-.176a.608.608 0 0 1 .112-.344l1.736-2.48H.4a.4.4 0 0 1-.4-.4v-.8c0-.22.18-.4.4-.4h.4v-8a1.6 1.6 0 0 1 1.6-1.6h4.8V.4c0-.22.18-.4.4-.4h.8c.22 0 .4.18.4.4v1.2h4.8a1.6 1.6 0 0 1 1.6 1.6v8h.4Zm-13.2 0h11.2v-8H2.4v8Z",
    clipRule: "evenodd"
  })));
};
export default SvgPitchicon;